// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"74716f68","694":"66c699a1","714":"60e47329","931":"d1c16eb0"}[chunkId] + ".chunk.css";
};